export default "__VITE_ASSET__c34ba012__"